// Dump magic numbers, constants, and reusable types all here

/** Item after it's been entered, validated, and parsed. */
export interface Item {
  text: string;
  price: number;
  people: string[];
}

/** Object associating a cost with a diner. */
export interface Due {
  name: string;
  cost: number;
}

/** For the line items that show up in the OCR modal.  */
export interface ReceiptItem {
  initialName: string;
  initialCost: string;
  index: number;
}

export const DONATION_LINK =
  "https://www.paypal.com/donate/?business=UY6UNQJTZTG5J&no_recurring=0&item_name=I+hope+my+tool+saved+your+group+some+stress%21&currency_code=USD";

// For local dev, use: http://127.0.0.1:5000/ocr
export const OCR_ENDPOINT = "https://bwliang.pythonanywhere.com/ocr";

/** What we show as a placeholder image for the OCR upload */
export const EXAMPLE_FILE =
  "https://artsmidnorthcoast.com/wp-content/uploads/2014/05/no-image-available-icon-6.png";

// From Sword Art Online
export const MAIN_BANNER_IMAGE =
  "https://otakotaku.com/asset/img/upload/2017/02/sao-ordinal-scale-wagnaria-3.jpg";
